export enum ViolationsReportType {
  SLICE_NAME = 'aag/violationsReport',
  API_SLICE_NAME = 'aag/violationsReportApi',
}

export interface ReportColumnState {
  id: string;
  localizationKey: string;
  isDefault: boolean;
}

export interface GetReportColumnsApiResponse {
  data: Record<string, ReportColumnState[]>;
  status: number;
  message: string;
}

export interface ReportTypeOptions {
  label: string;
  value: string;
  isChecked: boolean;
}

export type SodViolationReportData = Record<string, React.ReactElement>;

export interface GetSodViolationsReportPreviewRequest {
  filters: Record<string, unknown>;
}

export interface GetSodViolationsReportPreviewApiResponse {
  status: number;
  data: SodViolationReportData[];
  message: string;
  rowCount: number;
}

export interface CreateAsyncExportRequest {
  reportType: 'DETAIL' | 'SUMMARY' | 'PERMISSIONS';
  format: 'EXCEL' | 'CSV';
  columnConfig: {
    columnOrder: {
      riskName?: number;
      riskDescription?: number;
      riskPriority?: number;
      riskType?: number;
      riskCustomProperty1?: number;
      riskCustomProperty2?: number;
      riskOwner?: number;
      riskStatus?: number;
      functionName?: number;
      functionType?: number;
      functionOwner?: number;
      userName?: number;
      userFirstName?: number;
      userLastName?: number;
      city?: number;
      companyName?: number;
      costCenter?: number;
      country?: number;
      departmentName?: number;
      userDisplayName?: number;
      email?: number;
      employeeClass?: number;
      employeeId?: number;
      assignedEntitlementDisplayName?: number;
      violatingEntitlementDisplayNames?: number;
      assignedEntitlementCustomProperty4?: number;
      assignedEntitlementCustomProperty5?: number;
      assignedEntitlementDescription?: number;
      assignedEntitlementGlossary?: number;
      endpointDisplayName?: number;
      violationStatus?: number;
      actualVsPotential?: number;
      [key: string]: number | undefined; // Allow additional dynamic columns
    };
    selectedColumns: string[];
    columnDisplay?: Record<string, string>;
  };
  filters: {
    sodStatuses?: string[];
    [key: string]: unknown; // Allow additional filter properties
  };
  formattingOptions?: {
    excelOptions: {
      cellFormatting: {
        data: {
          dateFormat: string;
          numberFormat: string;
        };
      };
    };
  };
  fileName?: string;
  timezone?: string;
}

export interface CreateAsyncExportApiResponse {
  status: number;
  data: unknown;
  message: string;
}

export interface ExportStatusItem {
  status: string;
  progressPercentage: number;
  exportId: string;
  reportType: 'SUMMARY' | 'DETAIL' | 'PERMISSIONS';
  format: 'EXCEL' | 'CSV';
  createdAt: string;
  /** Server-suggested delay until the next status poll (ms). */
  nextPollingIntervalMs?: number;
  errorMessage?: string;
}

export interface GetExportStatusData {
  userId: string;
  totalExports: number;
  inProgressExports: number;
  completedExports: number;
  failedExports: number;
  exports: ExportStatusItem[];
}

export interface GetExportStatusApiResponse {
  status: number;
  data: GetExportStatusData;
  message: string;
}
